
// import React, { useState } from "react";
// import {
//   Box,
//   Card,
//   Typography,
//   Button,
//   Divider,
//   Grid,
//   RadioGroup,
//   Radio,
//   FormControlLabel,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   IconButton,
//   Checkbox,
// } from "@mui/material";
// import { Close as CloseIcon } from "@mui/icons-material";
// import { MdCancel } from "react-icons/md";
// import { CiSquarePlus, CiSquareMinus } from "react-icons/ci";
// import { Formik, Form, Field } from "formik";
// import { AiFillThunderbolt } from "react-icons/ai";
// import { Link, useNavigate } from "react-router-dom";
// // import "../../Pages/StakeNow/AddToCart/CartPageComponent/Modal/BannerinputGetModal.css";
// import "../../../Components/ModalCss/BannerinputGetModal.css";

// import { IoIosWarning } from "react-icons/io";
// import { useDispatch, useSelector } from "react-redux";
// // import actions from "../../../ReduxStore/actions";
// import { toast } from "react-toastify";
// import CustomInputLogin from "../../../Components/CustomInputLogin/CustomInputLogin";
// import * as Yup from "yup";
// import actions from "../../../ReduxStore/actions";
// import { clearCustomerId } from "../../../ReduxStore/Slices/Operator/customerSlice";
// import { clearTableGetId } from "../../../ReduxStore/Slices/TableId/TableIdGetSlice";
// import FullPageLoader from "../../FullPageLoader/FullPageLoader";

// const RejectCommendModal = ({
//   open,
//   onClose,
//   setGrams,
//   resetForm,
//   setSubmittedValues,
//   submittedValues,
//   modalHeadingName,
//   handleNextModal,
//   values,
//   handleSchemeModaClose,
//   onPreviewModalClose,
//   sectionNameForApproveAndReject
// }) => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const customerId = useSelector((state) => state.customer.customerId);
//   const { rejectHomeSection } = useSelector((state) => state?.rejectHomeSection);
//   const TableId = useSelector((state) => state.Table.TableId);
//   const [loading, setLoading] = useState(false);

//   const handleModalConfirm = async (values, resetForm) => {
//     setLoading(true)


//     console.log(values, "valuesss")
//     if (TableId) {
//       if (sectionNameForApproveAndReject === "HomeSection") {
//         const data1 = {
//           data: {
//             reject_comment: values.rejectCommend
//           },
//           method: "put",
//           apiName: `rejectHomeSection/${TableId}`,
//         };

//         const responseData = await dispatch(actions.REJECTHOMESECTION(data1));

//         if (responseData?.payload?.message === "Home section rejected successfully.") {
//           toast.success("Home section rejected successfully.")
//           setTimeout(() => {
//             resetForm()
//             onClose()
//             onPreviewModalClose()
//             dispatch(clearCustomerId(null))
//             dispatch(clearTableGetId(null))
//           }, 2500)
//         } else {
//           toast.error(responseData?.payload?.message)
//           setTimeout(() => {
//             resetForm()
//             onClose()
//             onPreviewModalClose()
//             dispatch(clearCustomerId(null))
//             dispatch(clearTableGetId(null))
//           }, 2500)
//         }
//       } else if (sectionNameForApproveAndReject === "StakeNowSection") {
//         const data1 = {
//           data: {
//             reject_comment: values.rejectCommend
//           },
//           method: "put",
//           apiName: `rejectStakeNowSection/${TableId}`,
//         };

//         const responseData = await dispatch(actions.REJECTSTSECTION(data1));

//         if (responseData?.payload?.message === "Stake Now section rejected successfully.") {
//           // toast.success("Stake Now section rejected successfully.")

//           setTimeout(() => {
//             setLoading(false)
//             onClose()
//             onPreviewModalClose()

//           }, 1500)

//           setTimeout(() => {
//             // setLoading(false)
//             toast.success("Stake Now section rejected successfully.")

//             dispatch(clearCustomerId(null))
//             dispatch(clearTableGetId(null))

//             resetForm()


//           }, 2500)

//           // setTimeout(() => {
//           //   resetForm()
//           //   onClose()
//           //   onPreviewModalClose()
//           //   dispatch(clearCustomerId(null))
//           //   dispatch(clearTableGetId(null))
//           // }, 2500)
//         } else {
//           // toast.error(responseData?.payload?.message)
//           // setTimeout(() => {
//           //   resetForm()
//           //   onClose()
//           //   onPreviewModalClose()
//           //   dispatch(clearCustomerId(null))
//           //   dispatch(clearTableGetId(null))
//           // }, 2500)
//           setTimeout(() => {
//             setLoading(false)
//             onClose()
//             onPreviewModalClose()

//           }, 1500)

//           setTimeout(() => {
//             // setLoading(false)
//             toast.error(responseData?.payload?.message)

//             dispatch(clearCustomerId(null))
//             dispatch(clearTableGetId(null))

//             resetForm()


//           }, 2000)
//         }
//       }
//       else if (sectionNameForApproveAndReject === "RefreralsSection") {
//         const data1 = {
//           data: {
//             reject_comment: values.rejectCommend
//           },
//           method: "put",
//           apiName: `rejectReferralSection/${TableId}`,
//         };

//         const responseData = await dispatch(actions.REJECTREFERRALSECTION(data1));

//         if (responseData?.payload?.message === "Referral Section rejected successfully.") {
//           toast.success("Referral section rejected successfully.")
//           setTimeout(() => {
//             resetForm()
//             onClose()
//             onPreviewModalClose()
//             dispatch(clearCustomerId(null))
//             dispatch(clearTableGetId(null))
//           }, 2500)
//         } else {
//           toast.error(responseData?.payload?.message)
//           setTimeout(() => {
//             resetForm()
//             onClose()
//             onPreviewModalClose()
//             dispatch(clearCustomerId(null))
//             dispatch(clearTableGetId(null))
//           }, 2500)
//         }

//       }
//     }
//     // onClose();

//   };
//   return (
//     <Dialog
//       open={open}
//       //   onClose={onClose}
//       fullWidth
//       maxWidth="md"
//       className="custom-dialog"
//       sx={{
//         zIndex: 1800,
//         "& .MuiPaper-root": {
//           maxWidth: "500px",
//           //   borderRadius: "2px",
//         },
//       }}
//     >
//       {loading && <FullPageLoader />}

//       <Box sx={{ position: "relative" }}>
//         {/* <Box className="dialog-heading">
//           <IconButton
//             aria-label="Close"
//             onClick={onClose}
//             sx={{
//               position: "absolute",
//               top: 8,
//               right: 8,
//               color: "text.secondary",
//             }}
//           >
//             <MdCancel />
//           </IconButton>
//           <DialogTitle className="custom-dialog-title">
//             <Box>
//               <Typography className="custom-title-text" color="white">
//                 Purchase Document
//               </Typography>
//             </Box>
//           </DialogTitle>
//         </Box> */}

//         <Formik
//           initialValues={{
//             rejectCommend: "",
//           }}
//           validationSchema={Yup.object().shape({

//             rejectCommend: Yup.string().required("Reject Commend is required"),
//           })}
//           onSubmit={(values, { resetForm }) => {
//             console.log(values, "Form values submitted");
//             handleModalConfirm(values, resetForm)

//             // handleRegisterCompleteOpenModal(); // Open the RegistrationCompleteModal
//             // regiterFormSubmitionFn(values, uploadedFiles);
//             // handleSubmit();
//             // resetForm();
//           }}
//         >
//           {({ handleSubmit, setFieldValue, resetForm, values }) => (
//             <Form onSubmit={handleSubmit}>
//               <DialogContent
//                 dividers
//                 sx={{
//                   padding: 0,
//                   "& .MuiDialogContent-root": {
//                     padding: 0,
//                   },
//                   color: "#7A7A7A",
//                   p: { xs: 2, md: "16px 24px" },
//                 }}
//               // sx={{ flexDirection: { xs: "column", md: "row" } }}
//               >
//                 <Grid
//                   item
//                   sx={{
//                     display: "flex",
//                     //   justifyContent: "center",
//                     alignItems: "center",
//                   }}
//                 >
//                   <Box>
//                     <IoIosWarning
//                       style={{
//                         // color: "#eba30a",
//                         color: "#C38F51",

//                         fontSize: "25px",
//                         marginRight: "5px",
//                       }}
//                     />
//                   </Box>
//                   <Typography
//                     variant="subtitle2"
//                     color="black"
//                     textAlign="center"
//                     sx={{ fontSize: "18px", fontWeight: "500" }}
//                   >
//                     Are you sure want to reject?
//                   </Typography>
//                 </Grid>
//                 <Grid item>
//                   <Box sx={{ mt: 2, ml: 1 }}>
//                     <CustomInputLogin
//                       name="rejectCommend"
//                       inputType="textarea"
//                       custPlaceholder="Enter Reject command"

//                     />
//                     {/* <Typography>

//                       Please confirm if this scheme will be added to the plan,
//                       and if any additional changes are needed before proceeding
//                     </Typography> */}
//                   </Box>
//                 </Grid>

//                 <Grid xs={12} mt={2}>
//                   <Grid
//                     container
//                     justifyContent="end"
//                     alignItems="center"
//                     spacing={2} // Add spacing between buttons
//                   >
//                     <Grid item>
//                       <Button
//                         onClick={() => onClose()}
//                         variant="contained"
//                         sx={{
//                           textTransform: "none",
//                           color: "white",
//                           fontSize: "14px",
//                           padding: { xs: "0px 10px", md: "0px 20px" },
//                           minHeight: "40px",
//                           // borderRadius: "23px",
//                           background: "#d5d3d3",
//                           boxShadow: "none",
//                           color: "black",
//                           // border: "1px solid black",
//                           // "&:hover": {
//                           //   backgroundColor: "#3B4056",
//                           //   color: "white",
//                           // },
//                         }}
//                       >
//                         Cancel
//                       </Button>
//                     </Grid>
//                     <Grid item>
//                       <Button
//                         type="submit"
//                         //   onClick={() => handleModalConfirm()}//
//                         variant="contained"
//                         sx={{
//                           textTransform: "none",
//                           color: "white",
//                           fontSize: "14px",
//                           boxShadow: "none",
//                           padding: { xs: "0px 10px", md: "0px 20px" },
//                           minHeight: "40px",
//                           // borderRadius: "23px",
//                           background: "#C38F51 0% 0% no-repeat padding-box",
//                           // "&:hover": {
//                           //   backgroundColor: "#3B4056",
//                           //   boxShadow: "none",
//                           // },
//                         }}
//                       //   disabled={!values.privacyChecked} // Disable button if checkbox is not checked
//                       >
//                         Confirm
//                       </Button>
//                     </Grid>
//                   </Grid>
//                 </Grid>
//               </DialogContent>
//             </Form>
//           )}
//         </Formik>
//       </Box>
//     </Dialog>
//   );
// };

// export default RejectCommendModal;





import React, { useState } from "react";
import {
  Box,
  Card,
  Typography,
  Button,
  Divider,
  Grid,
  RadioGroup,
  Radio,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Checkbox,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { MdCancel } from "react-icons/md";
import { CiSquarePlus, CiSquareMinus } from "react-icons/ci";
import { Formik, Form, Field } from "formik";
import { AiFillThunderbolt } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
// import "../../Pages/StakeNow/AddToCart/CartPageComponent/Modal/BannerinputGetModal.css";
import "../../../Components/ModalCss/BannerinputGetModal.css";

import { IoIosWarning } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
// import actions from "../../../ReduxStore/actions";
import { toast } from "react-toastify";
import CustomInputLogin from "../../../Components/CustomInputLogin/CustomInputLogin";
import * as Yup from "yup";
import actions from "../../../ReduxStore/actions";
import { clearCustomerId } from "../../../ReduxStore/Slices/Operator/customerSlice";
import { clearTableGetId } from "../../../ReduxStore/Slices/TableId/TableIdGetSlice";
import FullPageLoader from "../../FullPageLoader/FullPageLoader";

const RejectCommendModal = ({
  open,
  onClose,
  setGrams,
  resetForm,
  setSubmittedValues,
  submittedValues,
  modalHeadingName,
  handleNextModal,
  values,
  handleSchemeModaClose,
  onPreviewModalClose,
  sectionNameForApproveAndReject
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const customerId = useSelector((state) => state.customer.customerId);
  const { rejectHomeSection } = useSelector((state) => state?.rejectHomeSection);
  const TableId = useSelector((state) => state.Table.TableId);
  const [loading, setLoading] = useState(false);

  const handleModalConfirm = async (values, resetForm) => {
    setLoading(true)


    console.log(values, "valuesss")
    if (TableId) {
      if (sectionNameForApproveAndReject === "HomeSection") {
        const data1 = {
          data: {
            reject_comment: values.rejectCommend
          },
          method: "put",
          apiName: `rejectHomeSection/${TableId}`,
        };

        const responseData = await dispatch(actions.REJECTHOMESECTION(data1));

        if (responseData?.payload?.message === "Home section rejected successfully.") {
          setTimeout(() => {
            setLoading(false)
            onClose()
            onPreviewModalClose()

          }, 1500)

          setTimeout(() => {
            // setLoading(false)
            toast.error("Home section rejected successfully.")

            dispatch(clearCustomerId(null))
            dispatch(clearTableGetId(null))

            resetForm()


          }, 2000)
        } else {
          setTimeout(() => {
            setLoading(false)
            onClose()
            onPreviewModalClose()

          }, 1500)

          setTimeout(() => {
            // setLoading(false)
            toast.error(responseData?.payload?.message)

            dispatch(clearCustomerId(null))
            dispatch(clearTableGetId(null))

            resetForm()


          }, 2000)
        }
      } else if (sectionNameForApproveAndReject === "StakeNowSection") {
        const data1 = {
          data: {
            reject_comment: values.rejectCommend
          },
          method: "put",
          apiName: `rejectStakeNowSection/${TableId}`,
        };

        const responseData = await dispatch(actions.REJECTSTAKENOWSECTION(data1));

        if (responseData?.payload?.message === "Stake Now section rejected successfully.") {
          // toast.success("Stake Now section rejected successfully.")

          setTimeout(() => {
            setLoading(false)
            onClose()
            onPreviewModalClose()

          }, 1500)

          setTimeout(() => {
            // setLoading(false)
            toast.success("Stake Now section rejected successfully.")

            dispatch(clearCustomerId(null))
            dispatch(clearTableGetId(null))

            resetForm()


          }, 2500)

          // setTimeout(() => {
          //   resetForm()
          //   onClose()
          //   onPreviewModalClose()
          //   dispatch(clearCustomerId(null))
          //   dispatch(clearTableGetId(null))
          // }, 2500)
        } else {
          // toast.error(responseData?.payload?.message)
          // setTimeout(() => {
          //   resetForm()
          //   onClose()
          //   onPreviewModalClose()
          //   dispatch(clearCustomerId(null))
          //   dispatch(clearTableGetId(null))
          // }, 2500)
          setTimeout(() => {
            setLoading(false)
            onClose()
            onPreviewModalClose()

          }, 1500)

          setTimeout(() => {
            // setLoading(false)
            toast.error(responseData?.payload?.message)

            dispatch(clearCustomerId(null))
            dispatch(clearTableGetId(null))

            resetForm()


          }, 2000)
        }
      }
      else if (sectionNameForApproveAndReject === "RefreralsSection") {
        const data1 = {
          data: {
            reject_comment: values.rejectCommend
          },
          method: "put",
          apiName: `rejectReferralSection/${TableId}`,
        };

        const responseData = await dispatch(actions.REJECTREFERRALSECTION(data1));

        if (responseData?.payload?.message === "Referral Section rejected successfully.") {

          setTimeout(() => {
            setLoading(false)
            onClose()
            onPreviewModalClose()

          }, 1500)

          setTimeout(() => {
            // setLoading(false)
            toast.success("Referral Section rejected successfully.")

            dispatch(clearCustomerId(null))
            dispatch(clearTableGetId(null))

            resetForm()


          }, 2000)

        } else {
          setTimeout(() => {
            setLoading(false)
            onClose()
            onPreviewModalClose()

          }, 1500)

          setTimeout(() => {
            // setLoading(false)
            toast.error(responseData?.payload?.message)

            dispatch(clearCustomerId(null))
            dispatch(clearTableGetId(null))

            resetForm()


          }, 2000)

        }

      }
      else if (sectionNameForApproveAndReject === "AboutUsSection") {
        const data1 = {
          data: {
            reject_comment: values.rejectCommend
          },
          method: "put",
          apiName: `rejectAboutUsSection/${TableId}`,
        };

        const responseData = await dispatch(actions.REJECTABOUTUSSECTION(data1));

        if (responseData?.payload?.message === "About Us section rejected successfully.") {

          setTimeout(() => {
            setLoading(false)
            onClose()
            onPreviewModalClose()

          }, 1500)

          setTimeout(() => {
            // setLoading(false)
            toast.success("About us section rejected successfully.")

            dispatch(clearCustomerId(null))
            dispatch(clearTableGetId(null))

            resetForm()


          }, 2000)

        } else {
          setTimeout(() => {
            setLoading(false)
            onClose()
            onPreviewModalClose()

          }, 1500)

          setTimeout(() => {
            // setLoading(false)
            toast.error(responseData?.payload?.message)

            dispatch(clearCustomerId(null))
            dispatch(clearTableGetId(null))

            resetForm()


          }, 2000)

        }

      }
      else if (sectionNameForApproveAndReject === "BlogSection") {
        const data1 = {
          data: {
            reject_comment: values.rejectCommend
          },
          method: "put",
          apiName: `rejectBlogSection/${TableId}`,
        };

        const responseData = await dispatch(actions.REJECTBLOGSECTION(data1));

        if (responseData?.payload?.message === "Blog section rejected successfully.") {

          setTimeout(() => {
            setLoading(false)
            onClose()
            onPreviewModalClose()

          }, 1500)

          setTimeout(() => {
            // setLoading(false)
            toast.success("Blog section rejected successfully.")

            dispatch(clearCustomerId(null))
            dispatch(clearTableGetId(null))

            resetForm()


          }, 2000)

        } else {
          setTimeout(() => {
            setLoading(false)
            onClose()
            onPreviewModalClose()

          }, 1500)

          setTimeout(() => {
            // setLoading(false)
            toast.error(responseData?.payload?.message)

            dispatch(clearCustomerId(null))
            dispatch(clearTableGetId(null))

            resetForm()


          }, 2000)

        }

      }
      else if (sectionNameForApproveAndReject === "ContactUsSecttion") {
        const data1 = {
          data: {
            reject_comment: values.rejectCommend
          },
          method: "put",
          apiName: `rejectContactUsSection/${TableId}`,
        };

        const responseData = await dispatch(actions.REJECTCONTACTUSSECTION(data1));

        if (responseData?.payload?.message === "Contact Us section rejected successfully.") {

          setTimeout(() => {
            setLoading(false)
            onClose()
            onPreviewModalClose()

          }, 1500)

          setTimeout(() => {
            // setLoading(false)
            toast.success("Contact us section rejected successfully.")

            dispatch(clearCustomerId(null))
            dispatch(clearTableGetId(null))

            resetForm()


          }, 2000)

        } else {
          setTimeout(() => {
            setLoading(false)
            onClose()
            onPreviewModalClose()

          }, 1500)

          setTimeout(() => {
            // setLoading(false)
            toast.error(responseData?.payload?.message)

            dispatch(clearCustomerId(null))
            dispatch(clearTableGetId(null))

            resetForm()


          }, 2000)

        }

      }
    }
    // onClose();

  };
  return (
    <Dialog
      open={open}
      //   onClose={onClose}
      fullWidth
      maxWidth="md"
      className="custom-dialog"
      sx={{
        zIndex: 1800,
        "& .MuiPaper-root": {
          maxWidth: "500px",
          //   borderRadius: "2px",
        },
      }}
    >
      {loading && <FullPageLoader />}

      <Box sx={{ position: "relative" }}>
        {/* <Box className="dialog-heading">
          <IconButton
            aria-label="Close"
            onClick={onClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "text.secondary",
            }}
          >
            <MdCancel />
          </IconButton>
          <DialogTitle className="custom-dialog-title">
            <Box>
              <Typography className="custom-title-text" color="white">
                Purchase Document
              </Typography>
            </Box>
          </DialogTitle>
        </Box> */}

        <Formik
          initialValues={{
            rejectCommend: "",
          }}
          validationSchema={Yup.object().shape({

            rejectCommend: Yup.string().required("Reject Commend is required"),
          })}
          onSubmit={(values, { resetForm }) => {
            console.log(values, "Form values submitted");
            handleModalConfirm(values, resetForm)

            // handleRegisterCompleteOpenModal(); // Open the RegistrationCompleteModal
            // regiterFormSubmitionFn(values, uploadedFiles);
            // handleSubmit();
            // resetForm();
          }}
        >
          {({ handleSubmit, setFieldValue, resetForm, values }) => (
            <Form onSubmit={handleSubmit}>
              <DialogContent
                dividers
                sx={{
                  padding: 0,
                  "& .MuiDialogContent-root": {
                    padding: 0,
                  },
                  color: "#7A7A7A",
                  p: { xs: 2, md: "16px 24px" },
                }}
              // sx={{ flexDirection: { xs: "column", md: "row" } }}
              >
                <Grid
                  item
                  sx={{
                    display: "flex",
                    //   justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Box>
                    <IoIosWarning
                      style={{
                        // color: "#eba30a",
                        color: "#C38F51",

                        fontSize: "25px",
                        marginRight: "5px",
                      }}
                    />
                  </Box>
                  <Typography
                    variant="subtitle2"
                    color="black"
                    textAlign="center"
                    sx={{ fontSize: "18px", fontWeight: "500" }}
                  >
                    Are you sure want to reject?
                  </Typography>
                </Grid>
                <Grid item>
                  <Box sx={{ mt: 2, ml: 1 }}>
                    <CustomInputLogin
                      name="rejectCommend"
                      inputType="textarea"
                      custPlaceholder="Enter Reject command"

                    />
                    {/* <Typography>
                 
                      Please confirm if this scheme will be added to the plan,
                      and if any additional changes are needed before proceeding
                    </Typography> */}
                  </Box>
                </Grid>

                <Grid xs={12} mt={2}>
                  <Grid
                    container
                    justifyContent="end"
                    alignItems="center"
                    spacing={2} // Add spacing between buttons
                  >
                    <Grid item>
                      <Button
                        onClick={() => onClose()}
                        variant="contained"
                        sx={{
                          textTransform: "none",
                          color: "white",
                          fontSize: "14px",
                          padding: { xs: "0px 10px", md: "0px 20px" },
                          minHeight: "40px",
                          // borderRadius: "23px",
                          background: "#d5d3d3",
                          boxShadow: "none",
                          color: "black",
                          // border: "1px solid black",
                          // "&:hover": {
                          //   backgroundColor: "#3B4056",
                          //   color: "white",
                          // },
                        }}
                      >
                        Cancel
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        type="submit"
                        //   onClick={() => handleModalConfirm()}//
                        variant="contained"
                        sx={{
                          textTransform: "none",
                          color: "white",
                          fontSize: "14px",
                          boxShadow: "none",
                          padding: { xs: "0px 10px", md: "0px 20px" },
                          minHeight: "40px",
                          // borderRadius: "23px",
                          background: "#C38F51 0% 0% no-repeat padding-box",
                          // "&:hover": {
                          //   backgroundColor: "#3B4056",
                          //   boxShadow: "none",
                          // },
                        }}
                      //   disabled={!values.privacyChecked} // Disable button if checkbox is not checked
                      >
                        Confirm
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </DialogContent>
            </Form>
          )}
        </Formik>
      </Box>
    </Dialog>
  );
};

export default RejectCommendModal;
